export class CustomEventsElementObserver {
    constructor() {
        // карта, чтобы не обрабатывать элемент дважды
        this._processed = new WeakSet();

        // кастомные события: атрибут => DOM-событие
        this._customEvents = {
            onenter: 'keydown',
            // можно добавить другие кастомные события здесь
        };

        this._mo = new MutationObserver(this._handleMutations.bind(this));
        this._mo.observe(document.body, { childList: true, subtree: true });

        // разово для уже вёрстанных
        this._initExisting(document.body);
    }

    _initExisting(root) {
        Object.keys(this._customEvents).forEach(attrName => {
            root.querySelectorAll(`[${attrName}]`).forEach(el => {
                this._setupElement(el, attrName);
            });
        });
    }

    _handleMutations(mutations) {
        for (const mut of mutations) {
            if (mut.type !== 'childList') continue;
            mut.addedNodes.forEach(node => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                Object.keys(this._customEvents).forEach(attrName => {
                    if (node.hasAttribute?.(attrName)) {
                        this._setupElement(node, attrName);
                    }
                    node.querySelectorAll?.(`[${attrName}]`).forEach(el => {
                        this._setupElement(el, attrName);
                    });
                });
            });
        }
    }

    _setupElement(el, attrName) {
        // уже инициализировано?
        if (this._processed.has(el)) return;
        this._processed.add(el);

        // если есть debounce, не обрабатываем тут
        if (el.hasAttribute('debounce') || el.hasAttribute(`debounce-${attrName}`)) return;

        // только для onenter: активируем событие на Enter
        if (attrName === 'onenter') {
            const code = el.getAttribute(attrName);
            // eslint-disable-next-line no-new-func
            const rawFn = new Function('event', code);
            el.addEventListener('keydown', function(event) {
                if (event.key === 'Enter') {
                    rawFn.call(this, event);
                }
            });
        }
        // можно добавить обработку других кастомных событий здесь
    }
}